import { db, getUserPlanData, analytics } from "../services/firebase";
import React, { useState, useEffect } from "react";
import {
  collection,
  getDocs,
  getDoc,
  addDoc,
  Timestamp,
  query,
  where,
  deleteDoc,
  doc,
  updateDoc,
} from "firebase/firestore";
import { sendEmailVerification } from "firebase/auth";
import { auth, logout } from "../services/firebase";
import DashboardHeader from "../components/dashboardHeader";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { onAuthStateChanged } from "firebase/auth";
import MarketingNavbar from "../components/marketingNav";
import LoadingSpinner from "../components/loadingSpinner";
import NoUploadsYet from "../components/elements/noUploadsYet";
import ProjectCard from "../components/elements/drillCard.tsx";
import StorageBanner from "../components/elements/storageBanner.tsx";
import UpgradeModal from "../components/elements/upgradeModal.tsx";
import { toast } from "react-hot-toast";
import SearchAndFilter from "../components/elements/searchAndFilter.tsx";
import { Crown, PlusCircle, Trash2 } from "lucide-react";
import { logEvent } from "../services/evalMode.js";
import Footer from "../components/footer";
import FeedbackComponent from "../components/supportWidget/feedbackPopup.tsx";
import OnboardingChecklist from "../components/elements/onboardingChecklist.tsx";
import DeferredProfilingBanner from "../components/OnboardingFlow/DeferredProfilingBanner.tsx";
import BandCampGiveawayBanner from "../components/elements/bandCampGiveawayBanner.tsx";
import FeedbackSurvey from "../components/elements/feedbackSurvey.tsx";
import { EDITOR_ONBOARDING_STORAGE_COMPLETED } from "../components/onboarding/editorOnboardingSteps.tsx";
import { createDesignFromTemplate } from "../services/createDesignFromTemplate";

export default function MyDesigns() {
  const [drills, setDrills] = useState([]);
  const [sharedWithMeDrills, setSharedWithMeDrills] = useState([]);

  const [loading, setLoading] = useState(true);
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const [newDrillName, setNewDrillName] = useState("");
  const [userData, setUserData] = useState(null); // Store user data
  const [uploadingAvailable, setUploadingAvailable] = useState(true);
  const [isPro, setIsPro] = useState(false);
  const [pastDue, setPastDue] = useState(false);
  const [isPlanInactive, setIsPlanInactive] = useState(null); // Store user data
  const [isPlanCanceled, setIsPlanCanceled] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [storageLimit, setStorageLimit] = useState(5);
  const navigate = useNavigate();
  const [designTab, setDesignTab] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortBy, setSortBy] = useState("updated-desc");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDrill, setSelectedDrill] = useState(null);
  const [drillTemplates, setDrillTemplates] = useState([]);
  const [showEmailVerificationModal, setShowEmailVerificationModal] = useState(false);
  const [emailVerificationSent, setEmailVerificationSent] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setLoading(true);
        fetchDrills(auth.currentUser.uid); // Pass the user ID
        fetchUserData();
        console.log("user", user);
        if (user.emailVerified === false) {
          // toast.error("Please verify your email to continue using the app.");
          // setShowEmailVerificationModal(true);
          // logEvent(analytics, "email_verification_modal_shown", {
          //   user_id: auth.currentUser.uid,
          //   timestamp: Timestamp.now().toDate().toISOString(),
          // });
        }
        setLoading(false);
      } else {
        // alert("No user found, please log in");
        navigate("/login"); // Or redirect to login
      }
    });

    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, [auth, navigate]); // Include `navigate` in dependencies

  useEffect(() => {
    // Only check the upload status when both userData and drills are available
    if (userData && drills.length >= 0) {
      checkUploadStatus();
    }
  }, [userData, drills]);

  const fetchDrills = async (userId) => {
    if (!userId) return;
    setLoading(true);
    try {
      // Create a proper query to filter by user ID
      const designsQuery = query(
        collection(db, "designs"),
        where("createdBy", "==", userId)
      );

      const querySnapshot = await getDocs(designsQuery);
      const drillList = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setDrills(drillList);

      const designsRef = collection(db, "designs");
      // console.log("ID", userId);

      const sharedQuery = query(
        designsRef,
        where("collaboratorIds", "array-contains", {
          uid: userId,
        })
      );

      const sharedQuerySnapshot = await getDocs(sharedQuery);
      const sharedDrillList = sharedQuerySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      console.log("SHARED", sharedDrillList);
      setSharedWithMeDrills(sharedDrillList);

      const drillTemplatesRef = collection(db, "drillTemplates");
      // const drillTemplatesQuery = query(drillTemplatesRef, where("createdBy", "==", userId));
      const drillTemplatesSnapshot = await getDocs(drillTemplatesRef);
      const drillTemplatesList = drillTemplatesSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setDrillTemplates(drillTemplatesList);
      console.log("TEMPLATES", drillTemplatesList);

    } catch (error) {
      console.error("Error fetching drills:", error);
    }
    setLoading(false);
  };

  const fetchUserData = async () => {
    setLoading(true);
    // console.log(auth.currentUser.uid);
    try {
      // Query the "users" collection to find the document with the matching uid
      const q = query(
        collection(db, "users"),
        where("uid", "==", auth.currentUser.uid)
      );
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        // If we found a matching document, set the user data
        const userDoc = querySnapshot.docs[0]; // Assuming there's only one document per uid
        setUserData({ id: userDoc.id, ...userDoc.data() });
      } else {
        console.error("No user data found for the current UID");
      }
    } catch (error) {
      console.error("Error fetching user data: ", error);
    }
    setLoading(false);
  };
  const duplicateDrill = async (drillId) => {
    // if (!selectedDrill) return;
    try {
      const drillRef = doc(db, "designs", drillId);
      const drillSnapshot = await getDoc(drillRef);

      if (drillSnapshot.exists()) {
        const drillData = drillSnapshot.data();

        // Remove any fields that should not be duplicated, e.g., timestamps or unique identifiers
        const { createdAt, ...dataToDuplicate } = drillData;

        // Add a new document with duplicated data
        const newDrillRef = await addDoc(collection(db, "designs"), {
          ...dataToDuplicate,
          title: `${dataToDuplicate.title} (Copy)`, // Modify title to indicate a duplicate
          createdAt: new Date(),
        });

        console.log("Drill duplicated with ID: ", newDrillRef.id);
        setSelectedDrill(null);
        fetchDrills(auth.currentUser.uid); // Pass the user IDx
      } else {
        console.error("Drill not found!");
      }
    } catch (error) {
      console.error("Error duplicating drill: ", error);
    }
  };
  const handleUseTemplate = async (drillId) => {
    try {
      const newId = await createDesignFromTemplate(drillId, auth.currentUser.uid);
      console.log("Drill duplicated with ID: ", newId);
      setSelectedDrill(null);
      navigate(`/designs/${newId}`);
      fetchDrills(auth.currentUser.uid);
    } catch (error) {
      console.error("Error using template: ", error);
    }
  };
  const setDrillAsTemplate = async (drillId) => {
    // if (!selectedDrill) return;
    try {
      const drillRef = doc(db, "designs", drillId);
      const drillSnapshot = await getDoc(drillRef);

      if (drillSnapshot.exists()) {
        const drillData = drillSnapshot.data();

        // Remove any fields that should not be duplicated, e.g., timestamps or unique identifiers
        const { createdAt, ...dataToDuplicate } = drillData;

        // Add a new document with duplicated data
        const newDrillRef = await addDoc(collection(db, "drillTemplates"), {
          ...dataToDuplicate,
          title: `${dataToDuplicate.title}`, // Modify title to indicate a duplicate
          createdAt: new Date(),
          createdByName: "DrillFlo Team",
        });

        console.log("Drill template created with ID: ", newDrillRef.id);
        setSelectedDrill(null);
        fetchDrills(auth.currentUser.uid); // Pass the user IDx
      } else {
        console.error("Drill not found!");
      }
    } catch (error) {
      console.error("Error duplicating drill: ", error);
    }
  };
  const handleDeleteDrill = async () => {
    if (!selectedDrill) return;

    try {
      // Delete the drill from Firestore
      await deleteDoc(doc(db, "designs", selectedDrill.id));

      // Update the local state to reflect the deletion
      setDrills((prevDrills) =>
        prevDrills.filter((drill) => drill.id !== selectedDrill.id)
      );

      // Close the modal
      setShowDeleteModal(false);
      setSelectedDrill(null);
    } catch (error) {
      console.error("Error deleting drill:", error);
    }
  };
  const createNewDrill = async () => {
    setLoading(true);
    const uid = auth.currentUser.uid;
    const userRef = doc(db, "users", uid);
    const userDoc = await getDoc(userRef);
    const userRecord = userDoc.exists() ? userDoc.data() : {};
    const firstShowTitle = (
      userRecord.onboardingProfile?.firstShowTitle || ""
    ).trim();
    const title =
      drills.length === 0 && firstShowTitle
        ? firstShowTitle
        : "Untitled Drill Design";
    const newDrill = {
      title,
      createdAt: Timestamp.now(),
      createdBy: uid,
      updated: Timestamp.now(),
    };

    try {
      const docRef = await addDoc(collection(db, "designs"), newDrill);

      // Update the onboarding checklist
      if (userDoc.exists()) {
        const currentChecklist = userRecord.onboardingChecklist || {};

        await updateDoc(userRef, {
          onboardingChecklist: {
            ...currentChecklist,
            'create-drill': true
          }
        });
      }

      logEvent(analytics, "create_new_drill_document", {
        drill_title: newDrill.title,
        created_by: auth.currentUser.uid,
        created_at: Timestamp.now().toDate().toISOString(), // Log as ISO string for consistency
        document_id: docRef.id,
        // user_plan: "pro", // Replace with dynamic plan fetching if available
        device_type: navigator.userAgent.includes("Mobi")
          ? "mobile"
          : "desktop",
        // collaborators: 0, // Assuming no collaborators at creation
        // drill_type: "marching_band", // Example default value
      });
      setNewDrillName("");
      fetchDrills(auth.currentUser.uid); // Pass the user ID
      const firstDrill = drills.length === 0;
      const onboardingDone =
        localStorage.getItem(EDITOR_ONBOARDING_STORAGE_COMPLETED) === "true";
      const tutorialQs =
        firstDrill && !onboardingDone ? "?tutorial=1" : "";
      navigate(`/designs/${docRef.id}${tutorialQs}`);
    } catch (error) {
      console.error("Error adding document: ", error);
    }
    await delay(900);

    setLoading(false);
  };

  const checkUploadStatus = async () => {
    setLoading(true);
    setUploadingAvailable(true);

    try {
      const planData = await getUserPlanData(auth.currentUser.uid);
      console.log(planData);
      if (!planData || !userData) {
        console.error("Plan data or user data is missing");
        setLoading(false);
        return;
      }


      const { planKey, planActive } = planData;
      console.log("planKey", planKey)
      console.log("planActive", planActive)
      if (planKey === null && drills.length < 5) {
        console.log("planKey1")
        setIsPlanInactive(false);
        setUploadingAvailable(true);
        setStorageLimit(5);

        return;
      }
      if (planActive === false) {

        setIsPlanInactive(true);
        if (planKey === "past_due") {
          setPastDue(true);

        }
        if (planKey === "canceled") {
          setPastDue(false);
          setIsPlanCanceled(true);

        }
        setUploadingAvailable(false);
        return;
      }

      if (planActive === true) {

        setUploadingAvailable(true);
        setStorageLimit(10000);
        setIsPro(true);
      } else if (planKey === "free") {

        setStorageLimit(50);
      }

    } catch (error) {
      console.error("Error checking upload status:", error);
    } finally {

      await delay(900);
      setLoading(false);
    }
  };
  const oneWeekAgo = new Date();
  oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
  // console.log(oneWeekAgo);

  useEffect(() => {
    const drillsToLimit = drills.sort((a, b) => b.updated?.toDate() - a.updated?.toDate());
    if (isPlanCanceled === true) {
      setDrills(drillsToLimit.slice(0, 5));
    }
  }, [isPlanCanceled, pastDue]);

  const filterAndSortDrills = (drills) => {
    return drills
      .filter((drill) =>
        drill.title?.toLowerCase().includes(searchQuery?.toLowerCase())
      )
      .sort((a, b) => {
        switch (sortBy) {
          case "updated-desc":
            return b.updatedAt?.toDate() - a.updatedAt?.toDate() || b.updated?.toDate() - a.updated?.toDate();
          case "updated-asc":
            return a.updatedAt?.toDate() - b.updatedAt?.toDate() || a.updated?.toDate() - b.updated?.toDate();
          case "title-asc":
            return a.title.localeCompare(b.title);
          case "title-desc":
            return b.title.localeCompare(a.title);
          default:
            return 0;
        }
      });
  };

  if (loading)
    return (
      <>
        <MarketingNavbar />
        <LoadingSpinner />
      </>
    );
  return (
    <div className=" font-plusJakarta">
      <Helmet>
        <title>Drill Designs | DrillFlo</title>
      </Helmet>
      <MarketingNavbar />
      <OnboardingChecklist />
      <div className="mx-auto max-w-screen-xl px-4 pt-4 sm:px-6 lg:px-8">
        <BandCampGiveawayBanner />
        <DeferredProfilingBanner />
      </div>

      <header className="bg-white border-b border-gray-200 sticky top-0 z-40">
        <div className="mx-auto max-w-screen-xl px-4 py-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <h1 className="text-2xl font-bold text-blue-600">My Designs</h1>
              <div className="hidden md:flex items-center space-x-1 text-sm text-gray-500">
                <span>{drills.length} designs</span>
                <span>•</span>
                {/* <span>{storageLimit - drills.length} remaining</span> */}
              </div>
            </div>
            <div className="flex items-center space-x-4">
              {uploadingAvailable && (
                <button
                  onClick={createNewDrill}
                  className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:opacity-90 transition-all shadow-sm"
                >
                  <PlusCircle className="h-5 w-5 mr-2" />
                  New Design
                </button>
              )}
              {isPro !== true && isPlanCanceled !== true && pastDue !== true && (
                <button
                  onClick={() => setShowUpgradeModal(true)}
                  className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg hover:opacity-90 transition-all shadow-sm"
                >
                  <Crown className="h-5 w-5 mr-2" />
                  Try DrillFlo Pro Free for {process.env.REACT_APP_DRILLFLO_PRO_TRIAL_LENGTH || 15} Days
                </button>)}

              {isPro !== true && isPlanCanceled === true && (
                <button
                  onClick={() => setShowUpgradeModal(true)}
                  className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg hover:opacity-90 transition-all shadow-sm"
                >
                  <Crown className="h-5 w-5 mr-2" />
                  Upgrade to DrillFlo Pro
                </button>
              )}
            </div>
          </div>
        </div>
      </header>

      <StorageBanner
        currentUsage={drills.length}
        storageLimit={storageLimit}
        onUpgradeClick={() => setShowUpgradeModal(true)}
      />
      {pastDue && (
        <div className="bg-red-100 text-red-800 px-4 py-2 rounded-md">
          Your plan is past due. Please update your payment information to avoid losing access to your designs.
        </div>
      )}
      {isPlanCanceled && (
        <div className="bg-red-100 text-red-800 px-4 py-2 rounded-md">
          Your DrillFlo Pro subscription is no longer active. Please upgrade to continue using DrillFlo Pro.
        </div>
      )}

      <div className="bg-white border-b">
        <div className="mx-auto max-w-screen-xl px-4 sm:px-6 lg:px-8">
          <nav className="flex space-x-8 py-4">
            <button
              onClick={() => setDesignTab(1)}
              className={`${designTab === 1
                ? "text-blue-600 border-b-2 border-blue-600"
                : "text-gray-500 hover:text-gray-700 hover:border-gray-300"
                } px-1 py-2 text-sm font-medium border-b-2 border-transparent transition-colors`}
            >
              My Designs
            </button>
            <button
              onClick={() => setDesignTab(2)}
              className={`${designTab === 2
                ? "text-blue-600 border-b-2 border-blue-600"
                : "text-gray-500 hover:text-gray-700 hover:border-gray-300"
                } px-1 py-2 text-sm font-medium border-b-2 border-transparent transition-colors`}
            >
              Shared with Me
            </button>
            <button
              onClick={() => setDesignTab(3)}
              className={`${designTab === 3
                ? "text-blue-600 border-b-2 border-blue-600"
                : "text-gray-500 hover:text-gray-700 hover:border-gray-300"
                } px-1 py-2 text-sm font-medium border-b-2 border-transparent transition-colors`}
            >
              Templates
            </button>
          </nav>
        </div>
      </div>

      <div className="bg-gray-50 min-h-screen">
        <div className="mx-auto max-w-screen-xl px-4 py-8 w-full sm:px-6 lg:px-8">
          <SearchAndFilter
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            sortBy={sortBy}
            setSortBy={setSortBy}
          />

          {designTab === 1 && (
            <div className="mt-8">
              {uploadingAvailable === true && drills.length === 0 && (
                <div className="text-center py-12">
                  <div className="mx-auto w-64 h-64  rounded-full flex items-center justify-center mb-6">
                    <img src="/assets/dot/Dot.png" alt="Dot from DrillFlo" width={300} height={300} />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Create your first design</h3>
                  <p className="text-gray-500 mb-6 max-w-md mx-auto">Start by creating a new drill design or use one of our templates to get started quickly.</p>
                  <button
                    onClick={createNewDrill}
                    className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg hover:opacity-90 transition-all shadow-sm"
                  >
                    <PlusCircle className="h-5 w-5 mr-2" />
                    Create New Design
                  </button>
                </div>
              )}

              {uploadingAvailable === false && (<>
                <div className="text-center py-12 bg-white rounded-lg border border-gray-200 shadow-sm">
                  <div className="mx-auto w-24 h-24 bg-gradient-to-r from-blue-500 to-blue-700 rounded-full flex items-center justify-center mb-6">
                    <svg className="h-12 w-12 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Upgrade to Create More Designs</h3>
                  <p className="text-gray-500 mb-6 max-w-md mx-auto">You've reached your design limit. Upgrade your plan to create more designs and unlock premium features.</p>
                  <button
                    onClick={() => setShowUpgradeModal(true)}
                    className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-blue-500 to-blue-700 text-white rounded-lg hover:opacity-90 transition-all shadow-sm"
                  >
                    Upgrade Now
                  </button>
                </div>
                <div className="text-center py-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">

                  {filterAndSortDrills(drills).map((drill) => (
                    <ProjectCard
                      key={drill.id}
                      title={drill.title}
                      link={drill.id}
                      ownedDrill={true}
                      id={drill.id}
                      setSelectedDrill={() => setSelectedDrill(drill)}
                      setShowDeleteModal={setShowDeleteModal}
                      lastUpdated={(() => {
                        const updatedDate = drill.updatedAt?.toDate() || drill.updated?.toDate();
                        const today = new Date();
                        const yesterday = new Date();
                        yesterday.setDate(today.getDate() - 1);

                        if (updatedDate.toDateString() === today.toDateString()) {
                          return "Today";
                        } else if (updatedDate.toDateString() === yesterday.toDateString()) {
                          return "Yesterday";
                        } else if (updatedDate > oneWeekAgo) {
                          return updatedDate.toLocaleDateString(undefined, { weekday: "long" });
                        } else {
                          return updatedDate.toLocaleDateString();
                        }
                      })()}
                      thumbnail={drill.snapshotURL || "https://firebasestorage.googleapis.com/v0/b/cloud-drill-design.appspot.com/o/snapshots%2FuHksLWYzwdcq09JNvegv.png?alt=media&token=4e69d0f9-99e4-48e8-ba82-71e55f306830"}
                      favorite
                      status=""
                      duplicateDrill={null}
                      userData={userData}
                      setDrillAsTemplate={() => setDrillAsTemplate(drill.id)}
                    />
                  ))}
                </div>
              </>
              )}

              {uploadingAvailable && drills.length > 0 && (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                  <button
                    onClick={createNewDrill}
                    className="flex flex-col items-center justify-center p-8 border-2 border-dashed border-gray-300 rounded-xl hover:border-blue-500 hover:bg-blue-50 transition-all group bg-white"
                  >
                    <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center mb-4 group-hover:bg-blue-100 transition-colors">
                      <PlusCircle className="h-8 w-8 text-gray-400 group-hover:text-blue-500" />
                    </div>
                    <span className="font-medium text-gray-600 group-hover:text-blue-500">New Design</span>
                    <span className="text-sm text-gray-500 mt-1">Start from scratch</span>
                  </button>

                  {filterAndSortDrills(drills).map((drill) => (
                    <ProjectCard
                      key={drill.id}
                      title={drill.title}
                      link={drill.id}
                      ownedDrill={true}
                      id={drill.id}
                      setSelectedDrill={() => setSelectedDrill(drill)}
                      setShowDeleteModal={setShowDeleteModal}
                      lastUpdated={(() => {
                        const updatedDate = drill.updatedAt?.toDate() || drill.updated?.toDate();
                        const today = new Date();
                        const yesterday = new Date();
                        yesterday.setDate(today.getDate() - 1);

                        if (updatedDate.toDateString() === today.toDateString()) {
                          return "Today";
                        } else if (updatedDate.toDateString() === yesterday.toDateString()) {
                          return "Yesterday";
                        } else if (updatedDate > oneWeekAgo) {
                          return updatedDate.toLocaleDateString(undefined, { weekday: "long" });
                        } else {
                          return updatedDate.toLocaleDateString();
                        }
                      })()}
                      thumbnail={drill.snapshotURL || "https://firebasestorage.googleapis.com/v0/b/cloud-drill-design.appspot.com/o/snapshots%2FuHksLWYzwdcq09JNvegv.png?alt=media&token=4e69d0f9-99e4-48e8-ba82-71e55f306830"}
                      favorite
                      status=""
                      duplicateDrill={() => duplicateDrill(drill.id)}
                      userData={userData}
                      setDrillAsTemplate={() => setDrillAsTemplate(drill.id)}
                    />
                  ))}
                </div>
              )}
            </div>
          )}

          {designTab === 2 && (
            <div className="mt-8">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                {filterAndSortDrills(sharedWithMeDrills).map((drill) => (
                  <ProjectCard
                    key={drill.id}
                    title={drill.title}
                    link={drill.id}
                    ownedDrill={false}
                    lastUpdated={(() => {
                      const updatedDate = drill.updatedAt?.toDate() || drill.updated?.toDate();
                      const today = new Date();
                      const yesterday = new Date();
                      yesterday.setDate(today.getDate() - 1);

                      if (updatedDate.toDateString() === today.toDateString()) {
                        return "Today";
                      } else if (updatedDate.toDateString() === yesterday.toDateString()) {
                        return "Yesterday";
                      } else if (updatedDate > oneWeekAgo) {
                        return updatedDate.toLocaleDateString(undefined, { weekday: "long" });
                      } else {
                        return updatedDate.toLocaleDateString();
                      }
                    })()}
                    thumbnail={drill.snapshotURL || "https://media.sweetwater.com/m/products/image/f01cbad910PNt0umUIZ7D4QsGUaGKLoT3R5pDix9.wm-lw.png?quality=82&width=750&ha=f01cbad910f6d506"}
                    favorite
                    status=""
                  />
                ))}
                {sharedWithMeDrills.length === 0 && (
                  <div className="col-span-full text-center py-12 bg-white rounded-lg border border-gray-200">
                    <div className="mx-auto w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-6">
                      <svg className="h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                      </svg>
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">No shared designs yet</h3>
                    <p className="text-gray-500 max-w-md mx-auto">When someone shares a design with you, it will appear here.</p>
                  </div>
                )}
              </div>
            </div>
          )}

          {designTab === 3 && (
            <div className="mt-8">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                {filterAndSortDrills(drillTemplates).map((drill) => (
                  <ProjectCard
                    key={drill.id}
                    createdByName={drill.createdByName}
                    title={drill.title}
                    link={drill.id}
                    ownedDrill={false}
                    isTemplate={true}
                    handleUseTemplate={() => handleUseTemplate(drill.id)}
                    thumbnail={drill.snapshotURL}
                  />
                ))}
                {drillTemplates.length === 0 && (
                  <div className="col-span-full text-center py-12 bg-white rounded-lg border border-gray-200">
                    <div className="mx-auto w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-6">
                      <svg className="h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                      </svg>
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">No templates available</h3>
                    <p className="text-gray-500 max-w-md mx-auto">Check back soon for new drill design templates.</p>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      {showDeleteModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-8 rounded-xl shadow-lg max-w-md w-full mx-4">
            <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Trash2 className="h-6 w-6 text-red-600" />
            </div>
            <h2 className="text-xl font-bold text-center mb-2">Delete Design</h2>
            <p className="text-gray-600 text-center mb-6">
              Are you sure you want to delete <span className="font-semibold">{selectedDrill.title}</span>? This action cannot be undone.
            </p>
            <div className="flex justify-end space-x-4">
              <button
                onClick={() => setShowDeleteModal(false)}
                className="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleDeleteDrill}
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
              >
                Delete Design
              </button>
            </div>
          </div>
        </div>
      )}

      {showEmailVerificationModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-8 rounded-xl shadow-lg max-w-md w-full mx-4">
            <h2 className="text-xl font-bold text-center mb-2">Verify Your Email</h2>
            <p className="text-gray-600 text-center mb-6">
              Please verify your email to continue using DrillFlo.
            </p>
            {emailVerificationSent ? (
              <p className="text-gray-600 text-center mb-6">
                Verification email sent. Please check your inbox.
              </p>
            ) : (
              <button
                onClick={() => {
                  sendEmailVerification(auth.currentUser);
                  setEmailVerificationSent(true);
                }}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                Verify Email
              </button>
            )}
          </div>
        </div>
      )}

      <UpgradeModal
        isOpen={showUpgradeModal}
        userData={auth.currentUser.uid}
        onClose={() => setShowUpgradeModal(false)}
        currentUsage={drills.length}
        storageLimit={storageLimit}
        alreadyTrialed={pastDue || isPlanCanceled}
      />

      <FeedbackSurvey googleFormUrl="https://forms.gle/GHiwnbEetZ5zgW89A" />

      <div className="py-8" />
      <Footer />
    </div>
  );
}
